import React from 'react'
import PropTypes from 'prop-types'

import { View } from 'react-native'

import TextLoading from './TextLoading'

const MembersLoading = ({ width, style, spacing = 1 }) => {
  const styles = i => {
    return {
      paddingBottom: spacing * 4,
      paddingTop: i === 0 ? spacing * 4 : 0,
      ...style
    }
  }
  return [0, 1, 2, 3, 4].map(i => (
    <View key={i} style={styles(i)}>
      <TextLoading width={width} />
    </View>
  ))
}

MembersLoading.propTypes = {
  width: PropTypes.number,
  spacing: PropTypes.number
}

export default MembersLoading
